import Component from './Component';

export default class Alerts extends Component {
  load() {
    this.initAlerts();
    super.load();
  }

  initAlerts() {

    const bodyEl = document.querySelector('body');


    // open warning panel
    $(".warning-invisible-activator, .warning-details-panel").on('focus', function (e) {
      e.stopPropagation();
      // console.log('warning activator/panel focused');
      debounceMyFunction(e);
    });


    // click close
    $(".warning-invisible-activator").on('click', function (e) {
      // console.log('click close');
      debounceMyFunction(e);
    });


    // close warning panel when not focused
    bodyEl.addEventListener('focusin', (e) => {

      if (!e.target.classList.contains('warning-invisible-activator') && !e.target.classList.contains('warning-button-close') && !e.target.classList.contains('list-group-item-action')) {
        // console.log('_close alert panel');
        $(".warning-icon-right-div").show();
        $(".warning-details-panel").delay(500).hide();
        $(".warning-details-panel").removeClass('warning-details-panel-active');
      }

    }, true);  // capturing instead of bubbling


    // enter key to close warning panel
    $('.warning-invisible-activator, .warning-button-close').on('keypress',function(e) {
      if(e.which == 13) {
        $(".warning-icon-right-div").show();
        $(".warning-details-panel").delay(500).hide();
        $(".warning-details-panel").removeClass('warning-details-panel-active');
      }
    });


    // close warning panel when clicked outside
    bodyEl.addEventListener('click', function (e) {
      if (document.activeElement == document.body) {
        // close panel
        $(".warning-details-panel").removeClass('warning-details-panel-active');
        $(".warning-icon-right-div").show();
      }
    });

  }

}


function toggleWarningPanel() {
  if ($(".warning-details-panel").css('display') == 'none') {
    $(".warning-details-panel").show();
  }
  $(".warning-details-panel").toggleClass('warning-details-panel-active');
  $(".warning-icon-right-div").toggle();
}


function debounceMyFunction(e) {
  // console.log('e.target:', e.target);
  var now = new Date().getTime();
  var prevTime = $(e.target).data("prevActionTime");
  $(e.target).data("prevActionTime", now);
  // only call my function if we haven't just called it (within the last 0.1 second)
  if (!prevTime || now - prevTime > 100) {
    toggleWarningPanel();
  }
}
